import { AxiosRequestConfig } from 'axios';
import { store } from 'src/common/redux/configure-store';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { ITender } from '../../../common/interfaces/dtos/ITender';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const getValidSellableTender = async (eligibilityType?: string): Promise<ITender[]> => {
  const transactionId = store.getState().transaction.transactionId || 'NoTransactionId';
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/transaction-management/transactions/${transactionId}/valid-tenders`,
    params: {
      eligibilityType,
    },
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'Checkout - Valid Tenders' },
  };
  return emeraldRequest<ITender[]>(emeraldRequestParams);
};
